import { Popover } from 'antd'
import { Button } from 'antd'
import { FileTextOutlined } from '@ant-design/icons'
import { BBDTag, Texto } from '@gravitate-js/excalibrr'
import { Col, Row } from 'antd'

import { formatters } from '@utils/intl/dateTimeFormatters'
import { EbolStatusTag } from '@components/OrderMovements/OrderMovements/EbolMatching/EbolStatusTag'

export function BOLHeaderDisplay({ bol, attendantNote, orderId, timezone }) {
  return (
    <Row className='p-3 bol-header-row' align='middle'>
      <Col align='left' span={6}>
        <Row>
          <Texto weight='bold' category='h5' className='mr-2'>
            {bol.number}
          </Texto>

          <EbolStatusTag ebol_status={bol.ebol_status} orderId={orderId} bolId={bol.key} />

          {attendantNote?.note && (
            <Popover
              title={<Texto category='h6'>Attendant Note</Texto>}
              content={<Texto weight='bold'>{attendantNote?.note}</Texto>}
              placement='bottomLeft'
              overlayInnerStyle={{ wordWrap: 'break-word', maxWidth: '75ch' }}
            >
              <Button
                appearance='outline'
                theme2
                className='special-pay-note m-0 p-0'
                icon={<FileTextOutlined className='p-0 m-0' />}
              />
            </Popover>
          )}
        </Row>
      </Col>
      <Col span={2} className='mt-1'>
        Type:
        <BBDTag error={bol.type === 'drop'} theme2={bol.type === 'load'} className='ml-3'>
          {bol.type}
        </BBDTag>
      </Col>
      <Col span={7} className='mt-1' style={{ wordWrap: 'break-word', whiteSpace: 'pre-wrap' }}>
        Terminal: <b className='ml-3'>{bol?.location ? bol.location : null}</b>
      </Col>
      <Col span={6} className='mt-1'>
        Date/Time:
        <b className='ml-3'>{bol.date ? formatters.DATE_TIME(bol.date, timezone, true) : 'N/A'}</b>
      </Col>

      {bol.site && (
        <Col span={3} className='mt-1' style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}>
          Site: <b className='ml-3'>{bol.site}</b>
        </Col>
      )}
    </Row>
  )
}
